// @ts-ignore
 
import request from "src/lib/axios";

/** HQ 跨租户操作日志列表 GET /api/v1/hq/audit-log */
export async function HqAuditLogControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.HqAuditLogControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputAuditLogDtoArray>(
    "/api/v1/hq/audit-log",
    {
      method: "GET",
      params: {
        // pageSize has a default value: 10
        pageSize: "10",

        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",

        ...params,
      },
      ...(options || {}),
    }
  );
}

/** HQ 操作日志详情 GET /api/v1/hq/audit-log/${param0} */
export async function HqAuditLogControllerDetailV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.HqAuditLogControllerDetailV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputAuditLogDetailDto>(
    `/api/v1/hq/audit-log/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}
